import script from "./OTabelaTiposDeAtividade.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaTiposDeAtividade.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaTiposDeAtividade.vue?vue&type=style&index=0&id=69739716&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69739716"]])

export default __exports__